import { ScreenSizer } from '@react-three/drei'
import { Vector3 } from 'three'
import { DragControls, DragControlsProps } from './DragControls'

export function BoxDragControl({
  size = 16,
  position,
  visible,
  ...rest
}: { size?: number; position?: Vector3; visible?: boolean } & DragControlsProps) {
  return (
    <DragControls {...rest}>
      <ScreenSizer position={position} visible={visible}>
        <mesh>
          <boxGeometry args={[size, size, size]} />
          <meshBasicMaterial color="white" />
        </mesh>
        <mesh>
          <boxGeometry args={[size, size, size]} />
          <meshBasicMaterial color="#1273DE" wireframe wireframeLinewidth={1} />
        </mesh>
      </ScreenSizer>
    </DragControls>
  )
}
